import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, Typography, Select, message } from 'antd';
import {
	downloadLocationsCSVForSupplier,
	locationsRestCrudThunksForSupplier,
} from '../../thunks/locations_thunks';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { EmptyState } from '../empty_state/EmptyState';
import {
	nullSafeGet,
	changeFilterValueToArrayOfIds,
	getTupleNameFieldName,
	getTupleValueFieldName,
	nullSafeGetOrElse,
	isSupplierPayingCustomerAndAdmin,
} from '../../utils/DataAccessUtils';
import { EmptorTag } from '../emptor_tag/EmptorTag';
import { LOCATIONS_CRUD_ACTION_CREATORS } from '../../actions/locations_actions';
import {
	fetchRegionsWithChildrenForSupplier,
	regionsRestCrudThunksForSupplier,
} from '../../thunks/regions_thunks';
import { FILTER_CONFIG_NAMES, FILTER_FIELD_TYPE } from '../../utils/DataConstants';
import ProblemTypeTreeSelect from '../problem_type_tree_select';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import OWAsyncTupleSelect from '../ow_async_select/OWAsyncTupleSelect';
import { locationTypesAdditionalFieldsRestCrudThunksForSupplier } from '../../thunks/location_types_additional_fields_thunks';
import { SUPPLIER_ADMIN_ONLY } from '../roles/roles';
import { brandsRestCrudThunksForSupplier } from '../../thunks/brands_thunks';
import { locationTypesRestCrudThunksForSupplier } from '../../thunks/location_types_thunks';
import { getIsActiveFilterField, INITIAL_IS_ACTIVE_FILTERS } from '../../utils/FilterUtils';
import ReduxDataTable from '../redux_data_table/ReduxDataTable';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import { customersRestCrudThunksForSupplier } from '../../thunks/customers_thunks';
import { DownloadOutlined } from '@ant-design/icons';
import BrandLogoDisplay from '../brands_overview_index_page/BrandLogoDisplay';

require('./SupplierLocationsIndexPage.less');
const { Text } = Typography;

const TC_NAME = 'locationsIndex';

const LOCATIONS_OVERVIEW_TARGET_COLLECTION = 'locationsIndex';

class SupplierLocationsIndexPage extends React.Component<any, any> {
	formRefs: any;
	initialPagination: any = { current: 1, pageSize: 10 };
	initialFilters: any;

	constructor(props) {
		super(props);
		this.formRefs = {
			roleUpdateForm: null,
		};
		this.state = {
			displayMode: 'list',
		};
	}

	switchDisplayMode = (mode) => this.setState({ displayMode: mode });
	isDisplayModeActive = (mode) => this.state.displayMode === mode;

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	showRoleUpdateModal = (record) => (e) => {
		this.setState({
			roleUpdateVisible: true,
			userContact: {
				contact: {
					...record,
				},
				role: record['roles'],
				locationIds: record['locationIds'] || [],
			},
		});
	};
	handleClearAndUpdateFilters = (initialFilters, targetCollectionName) => {
		const { clearAndUpdateFilters, history } = this.props;
		history.push('/supplier/locations/overview/all');
		clearAndUpdateFilters({}, targetCollectionName);
	};

	downloadCSV = () => {
		const { locations, exportLocations } = this.props;
		const filters = nullSafeGetOrElse(`${TC_NAME}.filters`, locations, {});
		this.setState({ exporting: true });
		exportLocations(filters)
			.catch((err) => message.error(err))
			.finally(() => this.setState({ exporting: false }));
	};

	render() {
		const {
			history,
			locations,
			currentUser,
			location,
			updateLocationsFilters,
			regions,
			fetchRegionsWithChildren,
			fetchMultipleRegions,
			locationTypesAdditionalFields,
			fetchLocationTypesAdditionalFields,
			fetchMultipleLocationTypesAdditionalFields,
			brands,
			fetchBrands,
			fetchMultipleBrands,
			locationTypes,
			fetchLocationTypes,
			fetchMultipleLocationTypes,
			customers,
			fetchCustomers,
		} = this.props;
		const popupRenderFunc = (record) => `
            <div>
                <a href="/supplier/locations/detail/${record.id}">
                    <div class="locationsIndexPage__row" style="align-items: flex-start;">
                        <div style="margin-right: 24px;">
                            <div
                                class="locationsIndexPage__rowTitle"
                            >
                                ${record.name}
                            </div>
                            <div
                                class="locationsIndexPage__rowSubtitle"
                            >
                                    ${nullSafeGet(
																			'buyerFacility.primaryAddress.streetAddress1',
																			record
																		)}
                            </div>
                        </div>
                        <div class="emptorTag locationsIndexPage__pill">
                            ${
															record.totalNotClosedWOCount > 0
																? record.totalNotClosedWOCount + ' Open WOs'
																: 'No Open WOs'
														}
                        </div>
                    </div>
                    <div
                        class="locationsIndexPage__rowSubtitle"
                    >
                        <div class="locationsIndexPage__rowInlineGroup">
                            ${nullSafeGet(
															'buyerFacility.primaryAddress.city',
															record
														)}, ${nullSafeGet(
			'buyerFacility.primaryAddress.region',
			record
		)} ${nullSafeGet('buyerFacility.primaryAddress.postcode', record)}
                        </div>
                    </div>
                </a>
            </div>
        `;

		const columns = [
			{
				title: 'Name',
				dataIndex: 'name',
				defaultSortOrder: 'ascend',
				render: (text, record) => (
					<div className="locationsIndexPage__row">
						<div>
							<div className="flex items-center">
								<BrandLogoDisplay brand={nullSafeGet('brand', record)} />
								<div>
									<div className="locationsIndexPage__rowTitle">
										<Ellipsis tooltip={true} length={64}>
											{record.name}
										</Ellipsis>
									</div>
									<div className="locationsIndexPage__rowSubtitle">
										<div className="locationsIndexPage__rowInlineGroup">
											{nullSafeGet('buyerFacility.primaryAddress.city', record)}
										</div>
										<div className="locationsIndexPage__rowInlineGroup2">
											{nullSafeGet('locationType.name', record)} {nullSafeGet('storeId', record)}
											{isSupplierPayingCustomerAndAdmin(currentUser) ? (
												<span className="ml-2">
													| {nullSafeGet('buyerCompany.displayName', record)}
												</span>
											) : null}
										</div>
										{record.isActive ? null : (
											<div className="locationsIndexPage__rowInlineGroup">
												<Text className={'mr-1'} type={'danger'}>
													Inactive
												</Text>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
						<div className="locationsIndexPage__rightSide">
							<EmptorTag className="locationsIndexPage__pill">
								{record.totalNotClosedWOCount > 0
									? record.totalNotClosedWOCount + ' Open WOs'
									: 'No Open WOs'}
							</EmptorTag>
						</div>
					</div>
				),
			},
		];

		const onRow = (record) => ({
			onClick: () => {
				const path = `/supplier/locations/detail/${nullSafeGet(
					'id',
					record
				)}/details?targetCollectionName=${LOCATIONS_OVERVIEW_TARGET_COLLECTION}`;
				history.push(
					getLinkWIthBackLinkParams(location, 'Back to Assets', path, {
						preserve: true,
					})
				);
			},
		});

		const isAdmin = currentUser.roles.some((role) => SUPPLIER_ADMIN_ONLY.has(role));

		const filterConfig = [
			...(isSupplierPayingCustomerAndAdmin(currentUser)
				? [
						{
							label: 'Customers',
							mode: 'multiple',
							stateSlice: customers,
							fieldName: FILTER_CONFIG_NAMES.CUSTOMERS,
							filtersValueAccessor: (filtersStateSlice) => {
								const ids = nullSafeGet(
									`${LOCATIONS_OVERVIEW_TARGET_COLLECTION}.filters.${FILTER_CONFIG_NAMES.CUSTOMERS}`,
									filtersStateSlice
								);
								return changeFilterValueToArrayOfIds(ids);
							},
							keyAccessor: (customer) => customer.id,
							valueAccessor: (customer) => customer.id,
							handleChange: (ids) => {
								updateLocationsFilters(
									{
										[FILTER_CONFIG_NAMES.CUSTOMERS]: ids.join(',') || undefined,
									},
									LOCATIONS_OVERVIEW_TARGET_COLLECTION
								);
							},
							targetCollectionName: 'locationsAdvancedFilters',
							fetch: fetchCustomers,
							fetchMultiple: () => {},
							renderItem: (customer) => customer.displayName || customer.name,
							sortBy: { sort_by: 'name', order: 'ascend' },
						},
				  ]
				: []),
			{
				label: 'Region',
				mode: 'multiple',
				fieldName: FILTER_CONFIG_NAMES.REGION,
				stateSlice: regions,
				filtersValueAccessor: (filtersStateSlice) => {
					const ids = nullSafeGet(
						`${LOCATIONS_OVERVIEW_TARGET_COLLECTION}.filters.${FILTER_CONFIG_NAMES.REGION}`,
						filtersStateSlice
					);
					return changeFilterValueToArrayOfIds(ids);
				},
				keyAccessor: (region) => region.id,
				valueAccessor: (region) => region.id,
				handleChange: (ids) => {
					updateLocationsFilters(
						{
							[FILTER_CONFIG_NAMES.REGION]: ids.join(',') || undefined,
						},
						LOCATIONS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'locationsAdvancedFilters',
				fetch: fetchRegionsWithChildren,
				fetchMultiple: fetchMultipleRegions,
				renderItem: (region) => region.name,
				sortBy: { sort_by: 'name', order: 'ascend' },
				component: ProblemTypeTreeSelect,
			},
			{
				label: 'Location Type',
				mode: 'multiple',
				fieldName: FILTER_CONFIG_NAMES.LOCAATION_TYPE,
				stateSlice: locationTypes,
				filtersValueAccessor: (filtersStateSlice) => {
					const ids = nullSafeGet(
						`${LOCATIONS_OVERVIEW_TARGET_COLLECTION}.filters.${FILTER_CONFIG_NAMES.LOCAATION_TYPE}`,
						filtersStateSlice
					);
					return changeFilterValueToArrayOfIds(ids);
				},
				keyAccessor: (lt) => lt.id,
				valueAccessor: (lt) => lt.id,
				handleChange: (ids) => {
					updateLocationsFilters(
						{
							[FILTER_CONFIG_NAMES.LOCAATION_TYPE]: ids.join(',') || undefined,
						},
						LOCATIONS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'locationsAdvancedFilters',
				fetch: fetchLocationTypes,
				fetchMultiple: fetchMultipleLocationTypes,
				renderItem: (lt) => lt.name,
				sortBy: { sort_by: 'name', order: 'ascend' },
			},
			{
				label: 'Brand',
				mode: 'multiple',
				stateSlice: brands,
				fieldName: FILTER_CONFIG_NAMES.BRAND,
				filtersValueAccessor: (filtersStateSlice) => {
					const ids = nullSafeGet(
						`${LOCATIONS_OVERVIEW_TARGET_COLLECTION}.filters.${FILTER_CONFIG_NAMES.BRAND}`,
						filtersStateSlice
					);
					return changeFilterValueToArrayOfIds(ids);
				},
				keyAccessor: (brand) => brand.id,
				valueAccessor: (brand) => brand.id,
				handleChange: (ids) => {
					updateLocationsFilters(
						{
							[FILTER_CONFIG_NAMES.BRAND]: ids.join(',') || undefined,
						},
						LOCATIONS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'locationsAdvancedFilters',
				fetch: fetchBrands,
				fetchMultiple: fetchMultipleBrands,
				renderItem: (brand) => brand.brandName,
				sortBy: { sort_by: 'name', order: 'ascend' },
			},
			{
				label: 'Additional Fields',
				fieldName: FILTER_CONFIG_NAMES.ADDITIONAL_FIELD,
				type: FILTER_FIELD_TYPE.TUPLE,
				stateSlice: locationTypesAdditionalFields,
				filtersValueAccessor: (filtersStateSlice) => {
					const name = nullSafeGet(
						`${LOCATIONS_OVERVIEW_TARGET_COLLECTION}.filters.${getTupleNameFieldName(
							FILTER_CONFIG_NAMES.ADDITIONAL_FIELD
						)}`,
						filtersStateSlice
					);
					const value = nullSafeGet(
						`${LOCATIONS_OVERVIEW_TARGET_COLLECTION}.filters.${getTupleValueFieldName(
							FILTER_CONFIG_NAMES.INSTALL_AT
						)}`,
						filtersStateSlice
					);
					return [name, value];
				},
				handleChange: (values) => {
					updateLocationsFilters(
						{
							[getTupleNameFieldName(FILTER_CONFIG_NAMES.ADDITIONAL_FIELD)]: nullSafeGetOrElse(
								'0',
								values,
								undefined
							),
							[getTupleValueFieldName(FILTER_CONFIG_NAMES.ADDITIONAL_FIELD)]: nullSafeGetOrElse(
								'1',
								values,
								undefined
							),
						},
						LOCATIONS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'locationsAdvancedFilters',
				fetch: fetchLocationTypesAdditionalFields,
				fetchMultiple: fetchMultipleLocationTypesAdditionalFields,
				renderRecord: (entity) => (
					<Select.Option key={entity.id} value={entity.id}>
						<div className="flex flex-row items-center">
							<div>{entity.name}</div>
						</div>
					</Select.Option>
				),
				valueAccessor: (item) => item.name,
				component: OWAsyncTupleSelect,
			},
			...[getIsActiveFilterField(updateLocationsFilters, LOCATIONS_OVERVIEW_TARGET_COLLECTION)],
		];

		return (
			<div className="locationsIndexPage">
				<ReduxDataTable
					filterConfig={filterConfig}
					rightActions={
						<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<Button
								size="large"
								icon={<DownloadOutlined />}
								className="inline-block-visible-md"
								loading={this.state.exporting}
								onClick={this.downloadCSV}
							>
								<span className="inline-block-visible-xl">Export CSV</span>
							</Button>
							<Button.Group size="large">
								<Button
									onClick={() => this.switchDisplayMode('list')}
									disabled={this.isDisplayModeActive('list')}
								>
									<i className="icons8-font icons8-bulleted-list-2" />
								</Button>
								<Button
									onClick={() => this.switchDisplayMode('map')}
									disabled={this.isDisplayModeActive('map')}
								>
									<i className="icons8-font icons8-location-marker" />
								</Button>
							</Button.Group>
							{isAdmin ? (
								<Button
									size="large"
									type="primary"
									onClick={() => this.props.history.push('/supplier/locations/overview/new')}
								>
									Add Location
								</Button>
							) : null}
						</div>
					}
					mode={this.state.displayMode}
					updateQueryParams={true}
					longitudeAccessor={(el) => nullSafeGet('buyerFacility.longitude', el)}
					latitudeAccessor={(el) => nullSafeGet('buyerFacility.latitude', el)}
					emptyState={
						<EmptyState
							graphic={
								<img
									style={{ marginBottom: 8 }}
									src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
									alt={"It's a little lonely in here."}
								/>
							}
							headline={"It's a little lonely in here."}
							body={
								<div style={{ textAlign: 'center' }}>
									<div style={{ maxWidth: 440, marginBottom: 16 }}>
										Looks like your team has not added any locations yet.
									</div>
									<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_LOCATIONS}>
										<Button
											type="primary"
											onClick={() => this.props.history.push('/supplier/locations/overview/new')}
										>
											Add your first location
										</Button>
									</AccessPermissionChecker>
								</div>
							}
						/>
					}
					handleQueryParams
					collectionName="locations"
					entityCollectionName="locations"
					targetCollectionName={TC_NAME}
					tableColumns={columns}
					popupRenderFunc={popupRenderFunc}
					showHeader={false}
					keyAccessor={(el) => el.id}
					onTableRow={onRow}
					preAppliedFilters={{ ...INITIAL_IS_ACTIVE_FILTERS }}
					fetchData={locationsRestCrudThunksForSupplier}
					initialSorting={{ sort_by: 'name', order: 'ascend' }}
					stateSlice={locations}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	locations: state.locations,
	regions: state.regions,
	brands: state.brands,
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
	locationTypesAdditionalFields: state.location_types_additional_fields,
	locationTypes: state.location_types,
	customers: state.customers,
});

const mapDispatchToProps = (dispatch) => ({
	updateLocationsFilters: (filters, targetCollection) =>
		dispatch(LOCATIONS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(LOCATIONS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(filters, targetCollectionName)),
	fetchRegionsWithChildren: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			fetchRegionsWithChildrenForSupplier(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleRegions: (ids, targetCollectionName) =>
		dispatch(regionsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchMultipleLocationTypesAdditionalFields: (ids, targetCollectionName) =>
		dispatch(
			locationTypesAdditionalFieldsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
		),
	fetchLocationTypesAdditionalFields: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationTypesAdditionalFieldsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchBrands: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			brandsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchCustomers: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			customersRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleBrands: (ids, targetCollectionName) =>
		dispatch(brandsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchLocationTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationTypesRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleLocationTypes: (ids, targetCollectionName) =>
		dispatch(locationTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	exportLocations: (params, filters) => dispatch(downloadLocationsCSVForSupplier(params, filters)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupplierLocationsIndexPage));
